import store from "@/store/index"
/**
 * Route guard
 * We will set guards here, for checking if
 * the user has the right access level for
 * entering a specific route
 */
export function ifAuthenticated (to, from, next) {
  if (to.meta.guard !== undefined &&
    store.state.auth.user.permissions &&
    store.state.auth.user.permissions.indexOf("view/" + to.meta.guard) < 0) {
    next("/")
    return
  }
  if (store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next("/login")
}

export function ifNotAuthenticated (to, from, next) {
  if (!store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next("/")
}

export function hasPermissions (permissions = []) {
  let moduleOrder = {
    "DocumentsOverview": "/documents-overview",
    "Board": "/board",
    "Employees": "/employees",
    // "Prospects": "/prospects",
    "Projects": "/projects",
    "Companies": "/companies",
    "DocumentTemplate": "/document-templates",
    "Cars": "/cars",
    "Apartments": "/apartments",
    "Codelist": "/codelists",
    "User": "/user-management",
    "Finances": "/finances",
    "Lists": "/lists"
  }
  return (to, from, next) => {
    if (Object.keys(store.getters["auth/getUserDetails"]).length > 0) {
      for (let i = 0; i < permissions.length; i++) {
        if (!store.getters["auth/getUserDetails"].permissions) {
          next("/")
          return
        }
        if (!store.getters["auth/getUserDetails"].permissions.includes(permissions[i])) {
          for (let i = 0; i < Object.keys(moduleOrder).length; i++) {
            let currentModule = Object.keys((moduleOrder))[i]
            if (store.getters["auth/getUserDetails"].permissions.includes("view/" + currentModule)) return next(moduleOrder[currentModule])
          }
          next("/")
          return
        }
      }
    }
    next()
  }
}

export function hasRoles (roles = []) {
  return (to, from, next) => {
    let user = store.getters["auth/getUserDetails"]
    if (user.roles && user.roles.find(r => roles.includes(r.name))) {
      next()
      return
    }
    next("/")
  }
}

export function isAdmin (accessType = []) {
  return (to, from, next) => {
    for (let i = 0; i < accessType.length; i++) {
      if (!store.getters["auth/getUserDetails"].access_type) next("/")
      if (!store.getters["auth/getUserDetails"].access_type.includes(accessType[i])) next("/")
    }
    next()
  }
}
